import { BREAKPOINTS } from './../consts/breakpoints';
import { useMediaQuery } from './use-media-query';

type BreakpointKey = keyof typeof BREAKPOINTS;

export const useAppMediaQuery = (key: BreakpointKey) => {
  const width = BREAKPOINTS[key];

  return useMediaQuery(`(max-width: ${width}px)`);
};
